import React from 'react'

const Shadeddiv = ({shadedtext,underlinetext1,underlinetext2,underlinetext3}) => {
  return (
    <>
      <div className='flex flex-col gap-4 items-center w-full h-fit mt-28 '>
      <div className="  opacity-10 text-9xl text-white  uppercase tracking-widest lg:text-6xl sm:text-xl sm:mt-16 h-fit flex items-center  justify-center flex-wrap text-center w-3/4 ml-56 esm:tracking-normal esm:text-4xl esm:mb-4 esm:mt-2 lg:w-screen lg:ml-0">{shadedtext}
      </div> 
      {/* main heading */}
      <div className='text-white  text-3xl first-letter:text-4xl  tracking-widest absolute font-bold h-fit flex  flex-wrap text-center  justify-center w-full esm:text-xl top-44 lg:top-20 md:top-46'>
      {underlinetext1}  <span className='border-b-2 border-red '>{underlinetext2}</span> {underlinetext3} 
     </div>
     </div> 
    </>
  )
}
export default Shadeddiv
